export const motionOK = () =>
  window.matchMedia('(prefers-reduced-motion: no-preference)').matches
